import type { FunctionComponent, PropsWithChildren } from "react"

import Head from "next/head"

import { getLocaleTerritoryCode } from "@/modules/locales/getLocaleTerritoryCode"
import { useLocale } from "@/modules/locales/useLocale"

type MetaTagsProps = PropsWithChildren<{
  title?: string
  description?: string
  image?: string
  location?: string
}>

/**
 * This components will modify in the <head> of the document the meta tags.
 */
export const MetaTags: FunctionComponent<MetaTagsProps> = ({ title, description, image, children, location }) => {
  const currentLocale = useLocale()

  return (
    <Head>
      {/* Basic info */}
      {title && <title>{title}</title>}
      {description && <meta name="description" content={description} />}

      {/* Open Graph */}
      <meta property="og:locale" content={getLocaleTerritoryCode(currentLocale, "_")} />
      <meta property="og:site_name" content="JobTeaser" />
      {title && <meta property="og:name" content={title} />}
      {location && <meta property="og:location" content={location} />}
      {description && <meta property="og:description" content={description} />}
      {image && <meta property="og:image" content={image} />}

      {children}
    </Head>
  )
}
